class SqFtCalculator {
  constructor(el) {
    this.el = el;
    this.sectionId = el.dataset.sectionId;
    this.sqFtPerUnit = parseFloat(el.dataset.sqFt) || 0;
    // Display multiplier: scales the NUMBER shown to the shopper (not the cart
    // quantity). Lets a product with mixed container sizes report its amount in
    // one shared base unit, e.g. a 5-gallon bucket (multiplier 5) and a 1-gallon
    // jug (multiplier 1) both read "5 gallons" for the same coverage. Defaults
    // to 1 when the variant has no custom.square_foot_display_multiplier.
    this.multiplier = parseFloat(el.dataset.multiplier) || 1;
    this.unitSingular = el.dataset.unitSingular || 'unit';
    this.unitPlural = el.dataset.unitPlural || 'units';

    this.input = el.querySelector('.sq-ft-calculator__input');
    this.calcBtn = el.querySelector('[data-sq-ft-calculate]');
    this.resultEl = el.querySelector('[data-sq-ft-result]');
    this.unitsEl = el.querySelector('[data-sq-ft-units]');
    this.unitLabelEl = el.querySelector('[data-sq-ft-unit-label]');
    this.coverageEl = el.querySelector('[data-sq-ft-coverage]');
    this.sqFtValueEl = el.querySelector('[data-sq-ft-value]');

    this.variantSqFtMap = this._parseVariantData();
    this.variantMultiplierMap = this._parseMultiplierData();
    this.qtyInput = this._findQtyInput();

    this._bind();
  }

  _parseVariantData() {
    const dataEl = document.getElementById('SqFtVariantData-' + this.sectionId);
    if (!dataEl) return {};
    try { return JSON.parse(dataEl.textContent); } catch(e) { return {}; }
  }

  _parseMultiplierData() {
    const dataEl = document.getElementById('SqFtMultiplierData-' + this.sectionId);
    if (!dataEl) return {};
    try { return JSON.parse(dataEl.textContent); } catch(e) { return {}; }
  }

  _findQtyInput() {
    const productForm = document.getElementById('product-form-' + this.sectionId);
    return productForm
      ? productForm.querySelector('input.quantity__input')
      : document.querySelector('input.quantity__input');
  }

  _bind() {
    this.calcBtn.addEventListener('click', () => this.calculate());
    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') this.calculate();
    });

    // Variant changes. On a variant switch the theme runs updateVariantInputs(),
    // which sets `#product-form-{section} input[name="id"]` to the new variant
    // id and THEN dispatches a document-level `variant:changed` event. So by the
    // time the event fires, the form input is already the correct new variant.
    //
    // Important: the event's payload (event.detail.variant === this.currentVariant)
    // is NOT updated on a same-product switch, so it reports the originally
    // selected variant. Don't trust it — read the live id from the form input.
    document.addEventListener('variant:changed', () => this._refreshFromSelectedVariant());

    // Fallback for any code path that publishes the FoxTheme.pubsub event.
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      FoxTheme.pubsub.subscribe(
        FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
        () => this._refreshFromSelectedVariant()
      );
    }
  }

  _currentVariantId() {
    const form = document.getElementById('product-form-' + this.sectionId)
      || document.querySelector(`product-info[data-section="${this.sectionId}"]`);
    const input = form ? form.querySelector('input[name="id"]') : null;
    return input && input.value ? parseInt(input.value, 10) : null;
  }

  _refreshFromSelectedVariant() {
    this._onVariantChange(this._currentVariantId());
  }

  _onVariantChange(variantId) {
    if (variantId == null) return;

    const newSqFt = parseFloat(this.variantSqFtMap[variantId]);
    if (!newSqFt) return;

    this.sqFtPerUnit = newSqFt;

    const newMult = parseFloat(this.variantMultiplierMap[variantId]);
    this.multiplier = newMult > 0 ? newMult : 1;

    if (this.sqFtValueEl) this.sqFtValueEl.textContent = newSqFt;
    if (this.input.value) this.calculate();
  }

  calculate() {
    const sqFt = parseFloat(this.input.value);
    if (!sqFt || sqFt <= 0 || this.sqFtPerUnit <= 0) return;

    // units = number of containers to buy -> drives coverage and cart quantity.
    const units = Math.ceil(sqFt / this.sqFtPerUnit);
    const coverage = (units * this.sqFtPerUnit).toFixed(1);

    // displayUnits = amount shown to the shopper, expressed in the shared base
    // unit (containers x per-variant multiplier). This is a label only.
    const displayUnits = units * this.multiplier;

    this.unitsEl.textContent = displayUnits;
    this.coverageEl.textContent = coverage;

    if (this.unitLabelEl) {
      this.unitLabelEl.textContent = displayUnits === 1 ? this.unitSingular : this.unitPlural;
    }

    this.resultEl.classList.remove('hidden');

    if (this.qtyInput) {
      // Cart quantity is always the container count, never the multiplied label.
      this.qtyInput.value = units;
      this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

document.querySelectorAll('.sq-ft-calculator').forEach(el => new SqFtCalculator(el));